module.exports = __webpack_public_path__ + "static/img/back1.0d6cfc1b.jpg";